import { REFRESH_TEMPLATE, UPDATE_REFRESH_TEMPLATE_TIME } from '../actions/reduxAction';

const INITIAL_STATE = {
  isLoading: false,
  refreshTemplate: true,
  lastRefreshTemplate: undefined,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REFRESH_TEMPLATE: {
      return {
        refreshTemplate: !state.refreshTemplate,
        lastRefreshTemplate: new Date(),
      };
    }
    case UPDATE_REFRESH_TEMPLATE_TIME: {
      return {
        lastRefreshTemplate: action.payload,
      };
    }
    default:
      return state;
  }
};
